import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { UserProfileForm } from "./forms/UserProfileForm.jsx";
import { capitalizeFirstLetter } from "@/utils/stringUtils.js";
import PasswordForm from "./forms/PasswordForm.jsx";
import MyCompanies from "@/pages/user/MyCompanies.jsx";
import { ROLES } from "@/config/roles.js";
import LegalDocumentsTab from "./sections/LegalDocumentsTab.jsx";

const UserProfile = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("home");
  const roles = useSelector((state) => state.auth.roles);
  const isUser = roles?.includes(ROLES.USER);
  // Los documentos legales son del cliente, no del personal del despacho.
  const isClient =
    isUser &&
    !roles?.includes(ROLES.ADMIN) &&
    !roles?.includes(ROLES.SUPER_ADMIN);

  return (
    <>
      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                {/* mountOnEnter: "Mi cuenta" redirige a la ficha de la empresa al
                    montarse, y sin esto se montaba al abrir el perfil y el usuario
                    nunca llegaba a ver sus datos ni a cambiar su contraseña. */}
                <Tabs
                  mountOnEnter
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  id="uncontrolled-tab-example"
                  className="mb-3 text-capitalize-first"
                  justify
                >
                  <Tab eventKey="home" title={capitalizeFirstLetter(t("home"))}>
                    <UserProfileForm />
                  </Tab>
                  <Tab
                    eventKey="security"
                    title={capitalizeFirstLetter(t("security"))}
                  >
                    <PasswordForm />
                  </Tab>
                  {isUser && (
                    <Tab
                      eventKey="companies"
                      title={capitalizeFirstLetter(t("nav.account"))}
                    >
                      <MyCompanies />
                    </Tab>
                  )}
                  {isClient && (
                    <Tab eventKey="legal" title="Documentos legales">
                      <LegalDocumentsTab />
                    </Tab>
                  )}
                  <Tab
                    eventKey="activity"
                    title={capitalizeFirstLetter(t("activity"))}
                  >
                    List of activities
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserProfile;
